import styled from 'styled-components';

export const SpacerComponent = styled.div<{ margin: string | number }>`
  margin: ${({ margin }) =>
    typeof margin === 'string' ? margin : `${margin}px`};
`;
